import React, { useState } from 'react';
import { RobotOutlined } from '@ant-design/icons';
import { motion } from 'framer-motion';

interface FunCopilotButtonProps {
	onClick?: () => void;
	className?: string;
}

const FunCopilotButton: React.FC<FunCopilotButtonProps> = ({ onClick, className = '' }) => {
	const [isHovered, setIsHovered] = useState(false);

	return (
		<motion.button
			whileHover={{ y: -8, scale: 1.05, rotate: 2 }}
			whileTap={{ scale: 0.95 }}
			initial={{ y: 0, scale: 1, rotate: 0 }}
			animate={{
				y: isHovered ? -8 : 0,
				scale: isHovered ? 1.05 : 1,
				rotate: isHovered ? 2 : 0,
			}}
			transition={{
				type: 'spring',
				stiffness: 800,
				damping: 15,
				duration: 0.15,
			}}
			className={`
        relative w-[180px] h-12 rounded-full
        bg-gradient-to-r from-indigo-600 to-purple-600
        text-white font-semibold
        shadow-lg hover:shadow-xl
        transition-all duration-150 ease-in-out
        overflow-hidden
        group
        ${className}
      `}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			onClick={onClick}
		>
			{/* Shimmer effect */}
			<div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-150">
				<div className="absolute inset-0 bg-gradient-to-br from-white/20 via-transparent to-transparent animate-shimmer" />
			</div>

			{/* Pulsing ring */}
			<div className="absolute -inset-1 rounded-full border-2 border-indigo-500/30 animate-pulse-ring" />

			{/* Content */}
			<div className="relative z-10 flex items-center justify-center gap-2">
				<RobotOutlined className="text-lg" />
				<span>Try AI Copilot</span>
			</div>

			{/* Hover gradient overlay */}
			<div className="absolute inset-0 bg-gradient-to-br from-indigo-500/20 to-purple-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-150" />
		</motion.button>
	);
};

export default FunCopilotButton;
